import { Button, Tag } from 'antd';
import styled from 'styled-components';

export const TableContainer = styled.div`
  position: relative;
  overflow: scroll;
  width: 100%;
  z-index: 1;

  .ant-table-wrapper {
    height: 33em;
    border: 0.5px solid grey;
    border-radius: 5px;
    overflow-x: auto;
  }

  .row-disabled {
    background-color: #f5f5f5;
    color: #aaa;
    opacity: 0.7;
  }
`;

export const StyledButton = styled(Button)`
  padding: 0;
  margin-right: 10px;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 15px 0 0;
`;

export const Tiltle = styled.div`
  font-size: 18px;
  text-align: left;
  margin: 10px 20px 0;
`;

export const AvailableIntWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
`;

export const PartnerCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 15px 10px;
`;

export const PartnerLogoWrapper = styled.div`
  height: 140px;
  width: 140px;
  display: flex;
  justify-self: center;
  justify-content: center;
  margin-bottom: 8px;
`;

export const ActionWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledTag = styled(Tag)`
  font-size: 15px;
  text-align: center;
  padding: 15px 10px;
  border: 0;
  width: 120px;
`;

export const SummaryWrapper = styled.div`
  display: flex;
  width: 30%;
  justify-content: space-between;
  padding: 4px;
  margin-bottom: 10px;
`;

export const SummaryColumnHeader = styled.h3`
  color: #666;
  text-transform: capitalize;
`;
